import base from './base'

let controller = 'receipt'
let action = null

const Receipt = {
  async listReceipts (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'id',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    action = 'ListReceipts'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async verifyReceipt (orderNumber) {
    if (!orderNumber) {
      throw new Error('保证金业务编号为空')
    }
    action = `VerifyReceipt/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getReceiptDetail (orderNumber) {
    if (!orderNumber) {
      throw new Error('OrderNumber为空')
    }
    action = `Detail/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async checkViewPermission (orderNumber) {
    action = `CheckViewPermission/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getSupervisionPermission (orderNumber) {
    action = `GetSupervisionPermissions/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addReceipt (request) {
    action = 'CreateReceipt'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async draftReceipt (request) {
    action = 'SaveDraft'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async updateReceipt (request) {
    let orderNumber = JSON.parse(request).orderNumber
    if (!orderNumber) {
      throw new Error('提交数据不合法!orderNumber为空')
    }
    action = `Update/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: JSON.parse(request)
    }
    return base.request(reqModel)
  },

  async deleteReceipt (orderNumber) {
    if (!orderNumber) {
      throw new Error('OrderNumber为空')
    }
    action = `Delete/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async preAuditReceipt (orderNumber, request) {
    action = `PreAudit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async preAuditReceiptNoSign (orderNumber, request) {
    action = `PreAudit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditReceipt (orderNumber, request) {
    action = `Audit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async auditReceiptNoSign (orderNumber, request) {
    action = `Audit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditTerminate (orderNumber, request) {
    action = `AuditTerminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async auditTerminateNoSign (orderNumber, request) {
    action = `AuditTerminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async terminate (orderNumber, request) {
    action = `Terminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async terminateNoSign (orderNumber, request) {
    action = `Terminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  /**
   * 增加保函备注
   * @param {*} orderNumber 
   * @param {*} remark 
   * @returns 
   */
  async setReceiptRemark (orderNumber, remark) {
    action = `SetReceiptRemark/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: require('qs').stringify({remark: remark})
    }
    return base.requestRaw(reqModel)
  },

}

export default Receipt